/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Pricedropsdesc2Inputs */

const id_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan peringatan saat game diskon`)
};

const ms_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan makluman apabila permainan dijual`)
};

const da_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få alarmer når spil er på tilbud`)
};

const de_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen erhalten, wenn Spiele im Angebot sind`)
};

const en_us2_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get alerts when games go on sale`)
};

const es_es2_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe alertas cuando los juegos tengan descuento`)
};

const es_mx2_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe alertas cuando los juegos estén en oferta`)
};

const fil_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makatanggap ng alerto kapag naka-sale ang mga laro`)
};

const fr_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recevez des alertes lorsque les jeux sont en promotion`)
};

const it_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi avvisi quando i giochi sono in offerta`)
};

const hu_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riasztások, amikor a játékok akciósak`)
};

const nl_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvang waarschuwingen wanneer games in de aanbieding zijn`)
};

const no_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få varsler når spill er på salg`)
};

const pl_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrzymuj alerty, gdy gry są w promocji`)
};

const pt_br2_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get alerts when games go on sale`)
};

const pt_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba alertas quando os jogos estiverem em promoção`)
};

const ro_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primește alerte când jocurile sunt la reducere`)
};

const fi_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat hälytyksiä, kun pelit ovat alennuksessa`)
};

const sv_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få aviseringar när spel är på rea`)
};

const vi_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận cảnh báo khi game được giảm giá`)
};

const tr_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyunlar indirime girdiğinde uyarı alın`)
};

const cs_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostávejte výstrahy, když hry zlevní`)
};

const bg_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получавайте сигнали, когато игрите са на промоция`)
};

const ru_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте оповещения о скидках на игры`)
};

const uk_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримуйте сповіщення про знижки на ігри`)
};

const ar_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على تنبيهات عند تخفيض الألعاب`)
};

const hi_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब गेम बिक्री पर हों तो अलर्ट प्राप्त करें`)
};

const th_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับการแจ้งเตือนเมื่อเกมลดราคา`)
};

const ja_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームがセールになったらアラートを受け取る`)
};

const zh_cn2_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get alerts when games go on sale`)
};

const zh_hant1_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get alerts when games go on sale`)
};

const ko_notifications_simple_pricedropsdesc2 = /** @type {(inputs: Notifications_Simple_Pricedropsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 할인 시 알림 받기`)
};

/**
* | output |
* | --- |
* | "Get alerts when games go on sale" |
*
* @param {Notifications_Simple_Pricedropsdesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_pricedropsdesc2 = /** @type {((inputs?: Notifications_Simple_Pricedropsdesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Pricedropsdesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "ms") return ms_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "da") return da_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "de") return de_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "fil") return fil_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "fr") return fr_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "it") return it_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "hu") return hu_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "nl") return nl_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "no") return no_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "pl") return pl_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "pt") return pt_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "ro") return ro_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "fi") return fi_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "sv") return sv_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "vi") return vi_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "tr") return tr_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "cs") return cs_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "bg") return bg_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "ru") return ru_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "uk") return uk_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "ar") return ar_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "hi") return hi_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "th") return th_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "ja") return ja_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_pricedropsdesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_pricedropsdesc2(inputs)
	return ko_notifications_simple_pricedropsdesc2(inputs)
});
export { notifications_simple_pricedropsdesc2 as "notifications.simple.priceDropsDesc" }